import {
    apiClient,
    DynamicDatagrid,
    Grid,
    setAlert,
    AlertTypes,
    MuiDataGrid,
    Typography,
    Paper,
    Toc as TocIcon,
    MuiIcons
} from "@leap4/frontend";
import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {partnersBaseUrl} from "../../../../config/generals";
import {RootState} from "../../../../store/store";
import {useContext, useEffect, useState} from "react";
import {generateColumn} from "../../common/tableColumnsGenerator";
import {MetricsComparison} from "../../../shared/MetricsComparison/MetricsComparison.container";
import {getComparisonOptionsDates} from "../../common/time.utils";
import {useQuery} from "react-query";
import {urlService} from "../../../routing/urlsService";
import ReportHeader from "../../common/ReportHeader/ReportHeader";
import {setIsLoading} from "../../../../store/actions/dateRange.actions";
import {IDateRangeGState} from "../../../../interfaces/datesGlobalState.interface";
import {UserViewsContext} from "../../../../contexts/userViewsContext";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../shared/OneOrgOnly/OneOrgOnly";

const {Tag} = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;

export interface IPartnersOverview {
    selectedDates: {partners: []},
    dayAgo: {partners: []},
    weekAgo: {partners: []},
    monthAgo: {partners: []}
    specificComparisonDate: {partners: []}
}

const mapStateToProps = (state: RootState) => ({
    dates: state.dates,
    selectedOrganization: state.auth.selectedOrganizationId
});

const mapActions = {
    setIsLoading,
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;
export interface IPropsPartnerOverview extends PropsFromRedux {
    dates: IDateRangeGState
}

const _OverviewSupplyTable: React.FC<IPropsPartnerOverview> = ({
                                                                   dates: {
                                                                       startDate,
                                                                       endDate,

                                                                   },
                                                                   }) => {

    const [columns, setColumns] = useState<GridColDef[]>([])
    const [specificComparisonDate, setSpecificComparisonDate] = useState()
    const [data, setData] = useState<IPartnersOverview>(null)
    const [rows, setRows] = useState<any[]>([]);
    const {userViews} = useContext(UserViewsContext)
    const [compare, setCompare] = useState<any[]>([]);
    const [selectedDatesData, setSelectedDatesData] = useState<[]>([])
    const [optionalComparisonDates] = useState<any>(getComparisonOptionsDates(startDate, endDate))
    const [comparisonData, setComparisonData] = useState<{dayType: string, date: string}>(
        {dayType: 'dayAgo', date: specificComparisonDate}
    )



    useEffect(() => {
        const pickedDate: number = Number((new Date()).getDate() - (new Date(specificComparisonDate)).getDate())
        switch (pickedDate) {
            case 1:
                const userViewColumn1 = userViews.activePreset.tableViews.map(view => generateColumn(view, data.dayAgo.partners))
                const entityColumns1 = generateColumn('supplyPartner', compare)
                setColumns([entityColumns1, ...userViewColumn1])
                break;
            case 7:
                const userViewColumn7 = userViews.activePreset.tableViews.map(view => generateColumn(view, data.weekAgo.partners))
                const entityColumns7 = generateColumn('supplyPartner', compare)
                setColumns([entityColumns7, ...userViewColumn7])
                break;
            case 0:
                const userViewColumn0 = userViews.activePreset.tableViews.map(view => generateColumn(view, data.monthAgo.partners))
                const entityColumns0 = generateColumn('supplyPartner', compare)
                setColumns([entityColumns0, ...userViewColumn0])
                break;
            default:

                if (!isNaN(pickedDate)) {
                    setComparisonData({dayType: 'specificComparisonDate', date: specificComparisonDate})
                }
                break;
        }
    }, [specificComparisonDate]);


    const fetchGeneralData = async (body) => {
        const baseUrl = `${partnersBaseUrl}/supply/overview`;
        const apiResponse = await apiClient.post(baseUrl, {
            startDate,
            endDate,
            specificComparisonDate: specificComparisonDate || null
        })

        const apiData = apiResponse.data
        Object.keys(apiData).forEach(ad =>
            apiData[ad].partners = apiData[ad].partners.map((partner,) => {
                    partner.partner._id = partner.partner._id.concat(partner.partner._id)
                    partner._id = partner.partner._id
                    return partner
                }
            )
        ) // Double id, because link is dashboard made with id slice(24) for supply partner.

        setCompare(
            apiData[comparisonData.dayType].partners
        )
        setSelectedDatesData(apiData.selectedDates.partners)
        setData(apiData)
        setRows(apiData.selectedDates.partners.map((partner,) => {

            return createRowData(partner)
        }).filter(x => !!x))
    };


    function createRowData(item) {
        const {totals} = item;
        const profit = totals?.revenue - totals?.cost;
        return {
            id: item.partner._id,
            supplyPartner: item.partner.name,
            completion: totals?.completion || 0,
            profit: profit,
            profitPercent: (profit / totals?.revenue) * 100,
            fillRate: ((totals?.impressions || 0) / (totals?.requests)) * 100,
            cpm: totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000,
            rpm: totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000,
            vcr: totals?.impressions === 0 ? 0 : totals?.completion / totals?.impressions * 100,
            netProfit: totals?.netRevenue - totals?.netCost,
            ...totals
        }
    }


    useEffect(() => {
        const userViewColumn = userViews.activePreset.tableViews.map(view => generateColumn(view, compare))
        const entityColumns = generateColumn('supplyPartner', compare)
        setColumns([entityColumns, ...userViewColumn])
    },[compare])

    const {isLoading: isLoadingPartner, isRefetching: isRefetching} = useQuery(
        ['get-supplyPartners--query', [startDate, endDate], comparisonData.date],
        fetchGeneralData,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: true,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <ReportHeader breadcrumbsIcon={<Tag/>}
                          breadcrumbs={[
                              {text: "Supply partners dashboard", link: urlService.partnersOverviewSupply(), icon: <TocIcon/>},
                          ]}/>
            <Grid item sm={12} p={1}>
                <MetricsComparison
                    optionalComparisonDates={optionalComparisonDates}
                    specificComparisonDate={specificComparisonDate}
                    setSpecificComparisonDate={setSpecificComparisonDate}/>
            </Grid>
            <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: 'none'}} elevation={5}>
                <DynamicDatagrid rows={rows}
                                 columns={columns}
                                 loading={isLoadingPartner || isRefetching}
                                 refreshFunc={() => {
                                 }}
                                 loadError={false}
                                 pageSize={25}
                                 style={{minHeight: `75vh`, width: '100%'}}
                />
            </Paper>
        </>
    );
};

export const OverviewSupplyTable = connector(_OverviewSupplyTable)